// extracted by mini-css-extract-plugin
export var bodyRow = "_f4-d";
export var cardColumns = "_f4-e";
export var ellipsesOverflow = "_f4-2";
export var flatBottomCorners = "_f4-3";
export var flatTopCorners = "_f4-4";
export var headerActionsDropdown = "_f4-f";
export var headerBottomRow = "_f4-c";
export var headerTopRow = "_f4-b";
export var orderDetailsWrapper = "_f4-0";
export var orderInfoContainer = "_f4-1";
export var productDetails = "_f4-9";
export var productImage = "_f4-5";
export var responsiveTable = "_f4-8";
export var shipmentContainer = "_f4-a";
export var tableBottomLeft = "_f4-6";
export var tableBottomRight = "_f4-7";